if (!customElements.get('psalm-format-details')) {
  customElements.define('psalm-format-details', class extends HTMLElement {
    connectedCallback() {
      this.stop = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (!data?.variant || !document.getElementById(`MainProduct-${data.sectionId}`)) return;
        const panels = [...this.querySelectorAll('[data-format-id]')];
        const selected = panels.find(panel => panel.dataset.formatId === String(data.variant.id));
        if (!selected) return;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
      });
    }
    disconnectedCallback() { this.stop?.(); }
  });
}